import '/assets/styles/pages/order-summary.scss';
import { useState, useEffect } from 'react';
import config from '@wearetla/tla-essentials-tools/config';
import { Trans } from 'react-i18next';

// Context
// import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useNavigator, useParams } from '@wearetla/tla-essentials-tools/utilities/navigator';
import { useLottery } from '/utilities/lottery';
import { useTranslation } from '/utilities/i18n';

// Sections
import PageHeader from '/views/sections/page-header';
import OrderStatus from '/views/sections/order-status';

// Partials
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Icon from '@wearetla/tla-essentials-tools/partials/icon';
import Btn from '/views/partials/btn';
import Loader from '/views/partials/loader';
import LotteryHeadline from '/views/partials/lottery-headline';
import Pricebox from '/views/partials/pricebox';
import CheckoutSection from '/views/partials/checkout-section';

// Services
import orderServices from '/services/order';

const OrderSummary = () => {
	const { orderId } = useParams('orderSummary');
	// const { openModal } = useModals();
	const { redirect } = useNavigator();
	const {
		enabled: lotteryEnabled,
		initialized: lotteryInitialized,
		userLotteryStatus,
	} = useLottery();
	const { t } = useTranslation();

	const [sale, setSale] = useState(null);

	(useEffect(() => {
		if (sale?.id?.toString?.() !== orderId) {
			setSale(null);
			console.log({ sale, orderId });
			orderServices.getOrder(orderId).then((payload) => {
				if (payload.status === 1 || payload.status === 2) {
					setSale({
						...payload,
						// delivery_type: payload.delivery_types.find(type => type.id === payload.delivery_type),
					});

					window.localStorage.removeItem(config.productNotesPersistenceKey);
				} else {
					redirect('payment', { orderId });
				}
			});
		}
	}),
		[sale, orderId]);

	// Banner yalnızca sipariş çekiliş hakkı kazandırıyorsa (`lottery_count`) gösterilir.
	const lotteryCount = sale?.lottery_count ?? 0;

	return (
		<>
			<PageHeader backLink="account" title={t('Sipariş Özeti')} />
			<div className="loader-container">
				<Loader loading={!sale} />
				{sale && (
					<>
						<div className="summary-message">
							<Icon name="message-check" className="message-icon" /> {sale.status_text}
						</div>
						<OrderStatus className="summary-status" order={sale} />

						{lotteryEnabled && lotteryInitialized && lotteryCount > 0 && (
							<div className="wrapper summary-lottery">
								<LotteryHeadline />
								<div className="lottery-content">
									<p className="lottery-message">
										<Trans
											i18nKey={
												userLotteryStatus
													? 'Bu siparişinden <0>{{count}}</0> çekiliş hakkı kazandın!'
													: 'Kampanyaya katıl, bu siparişinden <0>{{count}}</0> çekiliş hakkı kazan; iPhone 17 ve AirPods kazanma şansını yakala!'
											}
											values={{ count: lotteryCount }}
											components={[<strong key="count" className="message-count" />]}
										/>
									</p>
									{userLotteryStatus && (
										<p className="lottery-note">
											{t('Hakların en geç 30 dakika içinde hesabına otomatik olarak tanımlanır.')}
										</p>
									)}
									<Btn tag="link" href="account.lottery" className="lottery-btn small yellow-light">
										{userLotteryStatus ? t('Çekiliş Haklarım') : t('Kampanyaya Katıl')}
									</Btn>
								</div>
							</div>
						)}

						{!!sale.delivery_type && (
							<CheckoutSection
								narrow
								className="summary-delivery"
								contentClassName="delivery-contentwrap"
								title={t('Servis Yöntemi')}
							>
								<Icon
									name={sale.delivery_type.id === 0 ? 'service-pickup' : 'service-table'}
									className="delivery-icon"
								/>
								<div className="delivery-textcontent">
									<strong className="delivery-title">{sale.delivery_type.title}</strong>
									<div className="delivery-price">
										+ <Pricebox horizontal price={sale.delivery_type.price} />
									</div>
								</div>
							</CheckoutSection>
						)}

						<CheckoutSection
							className="summary-products"
							contentClassName="products-contentwrap"
							title={t('Sepet')}
						>
							{sale.products.map((product) => (
								<div className="products-product" key={product.id}>
									<Img className="product-image" src={product.menu_product.image} />
									<div className="product-textcontent">
										<strong className="product-title">{product.menu_product.title}</strong>
										<Pricebox className="product-price" product={product} />
									</div>
									<div className="product-quantity">{product.quantity}x</div>
								</div>
							))}
						</CheckoutSection>

						<CheckoutSection
							narrow
							title={t('Ödeme Özeti')}
							contentClassName="payment-container"
							className="summary-payment"
						>
							<div className="payment-item">
								<strong>{t('Ürünler Toplamı')}</strong>
								<Pricebox horizontal price={sale.product_total_price} />
							</div>
							{(sale.extras ?? []).map((extra) => (
								<div className="payment-item" key={extra.id}>
									<strong>{extra.title}</strong>
									<Pricebox horizontal price={extra.price} />
								</div>
							))}
							<div className="payment-item highlight">
								<strong>{t('Toplam')}</strong>
								<Pricebox horizontal price={sale.total_price} />
							</div>
						</CheckoutSection>
					</>
				)}
			</div>
		</>
	);
};

export default OrderSummary;
